import React from 'react';
import clsx from 'clsx';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuListItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { Dialog, Scrollbars } from '@shared/components';
import { AppContext } from '@shared/contexts';
import { THEME_VARIANT } from '@shared/constants';

import AboutIcon from '@assets/icons/about.svg';
import AltBrandLogo from '@assets/icons/brand-logo-alt.png';
import BrandLogo from '@assets/icons/brand-logo.png';
import RingCentralLogo from '@assets/icons/ringcentral-logo.svg';

import useStyles from './style';
import { Button } from '@material-ui/core';

const AboutModal = ({ classes: passedClasses = {}, version }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = React.useState(false);

  const { selectedThemeVariant } = React.useContext(AppContext);

  return (
    <>
      <MenuListItem onClick={() => setIsOpen(true)}>
        <ListItemIcon className={passedClasses.icon}>
          <img src={AboutIcon} alt='' width={16} />
        </ListItemIcon>
        <ListItemText className={passedClasses.label} primary='About' />
      </MenuListItem>
      <Dialog
        classes={{
          paper: classes.dialog,
        }}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <Dialog.Title hasClose />
        <Dialog.Content>
          <Scrollbars>
            <div className='color-text-secondary d-flex flex-column f-justify-between f-align-start pr-5'>
              <Typography
                className='mb-4 color-text-primary bold-font'
                variant='h6'
              >
                RingCentral SIP Viewer
              </Typography>
              <Typography className='mb-4' variant='subtitle2'>
                Release {version.release}, Build {version.build}
              </Typography>
              <Typography className='mb-4' variant='body2'>
                &copy; 2021 RingCentral Inc. All Rights Reserved
              </Typography>
              <Typography className='mb-4 color-text-primary' variant='button'>
                Acknowledgements
              </Typography>
              <Typography variant='subtitle2' className='mb-4'>
                Designed and created by John Celoria, Kyle Cleveland, Brittni
                Fisher and Andrew Miller.
              </Typography>
              <div className='d-flex f-align-end'>
                <Typography variant='subtitle2'>Illustrations by </Typography>
                <a
                  target='_blank'
                  href='https://icons8.com'
                  rel='noopener noreferrer'
                  className='color-text-link ml-1'
                >
                  <Typography variant='subtitle2'>Icons8</Typography>
                </a>
              </div>
            </div>
          </Scrollbars>
        </Dialog.Content>
        <Dialog.Actions>
          <Button
            variant='contained'
            color='primary'
            className='mr-4 mb-4'
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Done
          </Button>
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default AboutModal;
